import BaseSkeleton from 'components/Generic/BaseSkeleton';
import React from 'react';

import styles from '../../../styles/FundsTableRowSkeleton.module.scss';

const FundsTableRowSkeleton: React.FC = () => {
  return (
    <tr className={`${styles.skeleton} skeleton-row`}>
      <td colSpan={10} className="skeleton px-0">
        <BaseSkeleton className="w-100 d-none d-xl-block" height="56px" />
        <BaseSkeleton className="w-100 d-block d-xl-none" height="48px" />
      </td>
      <td colSpan={10} className="skeleton d-xl-none">
        <BaseSkeleton className="w-100 d-none d-md-block" height="48px" />
        <BaseSkeleton className="w-100 d-block d-md-none" height="56px" />
      </td>
      <td colSpan={10} className="skeleton d-xl-none">
        <BaseSkeleton className="w-100 d-block" height="72px" />
      </td>
      <td colSpan={10} className="skeleton d-xl-none">
        <BaseSkeleton className="w-100 d-block" height="72px" />
      </td>
      <td colSpan={10} className="skeleton d-xl-none">
        <BaseSkeleton className="w-100 d-block" height="72px" />
      </td>
      <td colSpan={10} className="skeleton d-xl-none">
        <BaseSkeleton className="w-100 d-block" height="72px" />
      </td>
    </tr>
  );
};

export default FundsTableRowSkeleton;
